import React from "react";
import AxiosConfig from "axiosConfig";
import "./Feeds.css";
import * as CONSTANT from "constants/text";
import ProfilePic from "components/General/ProfilePic";
import UploadPhoto from "site_media/images/Settings_Camera.png";
import UploadVideo from "site_media/images/Upload_Video.png";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import ButtonBase from "@material-ui/core/ButtonBase";
import SendIcon from "@material-ui/icons/Send";
import CancelIcon from "@material-ui/icons/Cancel";
import TextTheme from "components/General/Text/TextTheme";
import CustomInputPopup from "components/General/Form/Popup/CustomInputPopup";
import CustomImagePopup from "components/General/Form/Popup/CustomImagePopup";
import CustomCreationSuitePopup from "components/General/Form/Popup/CustomCreationSuitePopup";
import { Player } from "video-react";
import imageCompression from "browser-image-compression";
import TextArea from "../General/Form/TextArea";
import {validImages} from '../Spotlight/Album/ValidFiles';

class AddNewsfeedPost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profilePic: "",
      postText: "",
      displayPhoto: "",
      uploadPhoto: null,
      video:"",
      finalVideo:"",
      fileData:null,
      count:1,
      displayCreationSuite:false,
      displayImagePopup:false,
      displayCustomPopup:false,
      displayInputPrompt: false,
      youtubeURL: "",
      videoID: "",
      urlAdded: false,
      full_name: "",
    };

    //function bindings
    this.onRemovePhoto = this.onRemovePhoto.bind(this);
    this.onPostSubmit = this.onPostSubmit.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleCreationSuiteUpload = this.handleCreationSuiteUpload.bind(this);
    this.handleTextFieldOnChange = this.handleTextFieldOnChange.bind(this);
    this.openPopUp = this.openPopUp.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.openCustomPopUp = this.openCustomPopUp.bind(this);
    this.openCreationSuite = this.openCreationSuite.bind(this);
    this.uploadApi = this.uploadApi.bind(this);
    this.closeCreationSuite = this.closeCreationSuite.bind(this);
    this.openPrompt = this.openPrompt.bind(this);
    this.closePrompt = this.closePrompt.bind(this);
    this.onPromptFieldChange = this.onPromptFieldChange.bind(this);
    this.onPromptAddPressed = this.onPromptAddPressed.bind(this);
    this.onRemoveVideo = this.onRemoveVideo.bind(this);
  }

  /*
   * componentDidMount fetch the user's profilePic
   */
  componentDidMount() {
    AxiosConfig.get("/profile/details/profile-picture/").then((res) => {
      this.setState({
        profilePic: res.data.profile_pic,
        full_name: res.data.full_name,
      });
    });
  }
  handleCreationSuiteUpload(val){
    const imageFile = val;
    if (imageFile) {
      // set state and remove upload photo
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      const fileSize = imageFile.size / 1024;
      if (fileSize > 180) {
        imageCompression(imageFile, options)
          .then((compressedFile) => {
            this.setState({
              displayPhoto: URL.createObjectURL(compressedFile),
              uploadPhoto: compressedFile,
              videoID: "",
              video: "",
              finalVideo: "",
              youtubeURL: "",
              urlAdded: false,
              displayImagePopup: false,
            });
          })
          .catch(() => { });
      } else {
        this.setState({
          displayPhoto: URL.createObjectURL(imageFile),
          uploadPhoto: imageFile,
          videoID: "",
          youtubeURL: "",
          video: "",
          finalVideo: "",
          urlAdded: false,
          displayImagePopup: false,
        });
      }
    }
  }
  fileUpload(){
    const imageFile = this.state.fileData;
    if (imageFile) {
      // set state and remove upload photo
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      const fileSize = imageFile.size / 1024;
      if (fileSize > 180) {
        imageCompression(imageFile, options)
          .then((compressedFile) => {
            this.setState({
              displayPhoto: URL.createObjectURL(compressedFile),
              uploadPhoto: compressedFile,
              videoID: "",
              video: "",
              finalVideo: "",
              youtubeURL: "",
              urlAdded: false,
              displayImagePopup: false,
              displayCustomPopup:false,
            });
          })
          .catch((error) => { });
      } else {
        this.setState({
          displayPhoto: URL.createObjectURL(imageFile),
          uploadPhoto: imageFile,
          videoID: "",
          youtubeURL: "",
          video: "",
          finalVideo: "",
          urlAdded: false,
          displayImagePopup: false,
          displayCustomPopup: false,
        });
      }
    }
  }
  uploadApi(){
    const file = this.state.fileData;
    let form_data = new FormData();
    form_data.append("media", file);
    form_data.append("username", '');
    form_data.append("file_type", file.type);
    form_data.append("media_type", this.readMediaType(file.name));
    form_data.append("user_access", 'P');
    form_data.append("media_source", 'U');
    form_data.append("belongs_in", 'A');
    let album_form = form_data;
    album_form.append("belongs_in", 'C');

    AxiosConfig.post('mediaManager/media/', album_form, {//HTPP POST Request
      headers: {
        "content-type": "multipart/form-data",
      },
    }).then(res => {
      this.setState({
        displayCreationSuite: true
      })
    }).catch(err => {
    });
   
  }
  getExtension(file) {
    let ext = "";
    ext = file.split('.').pop();
    return ext;
  }
  readMediaType(file) {
    let ext = "";
    ext = this.getExtension(file);
    if (validImages().indexOf(ext) > -1) {
      return 'I';
    }
    else {
      return "";
    }
  }
  /*
   * Function to change the uploaded image state on a file change.
   */
  handleImageChange(e) {
    const imageFile = e.target.files[0];
    if(imageFile.type.includes("image") ){
        this.openCustomPopUp(imageFile);
      }
    else if (imageFile.type.includes("video")){
    this.setState({
      video: URL.createObjectURL(imageFile),
      finalVideo: imageFile,
      displayImagePopup: false,
      displayPhoto: "",
      uploadPhoto: "",
      videoID: "",
      youtubeURL: "",
    });
  }
  }
  /*
   * Handle a post submit.
   */
  onPostSubmit(event) {
    let obj = this;

    if (this.state.postText) {
      //construct form similar to StartProjectStepOne.js
      let form_data = new FormData();
      form_data.append("post_body", this.state.postText);
      if (this.props.isGroup) {
        form_data.append("groupId", this.props.groupID);
        form_data.append("action_type", CONSTANT.GROUP_CUSTOM_POST);
      } else {
        form_data.append("action_type", CONSTANT.CUSTOM_POST);
      }

      //Check that the user uploaded an image. if not don't add it to the response.
      if (this.state.uploadPhoto) {
        form_data.append(
          "post_image",
          this.state.uploadPhoto,
          this.state.uploadPhoto.name
        );
      }
      //Check that the user has uploaded a youtube link. if not don't add it to the response.
      if (this.state.urlAdded) {
        form_data.append("youtube_id", this.state.videoID);
      }
      if (this.state.video){
        form_data.append("post_video", this.state.finalVideo);
      }
      //POST the data
      AxiosConfig.post(`posts/create/`, form_data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      }).then(function (response) {
        obj.props.onPostAdded(response.data);
      });
      // reset the state of the add a newsfeed post.
      this.resetState();
    } else {
      this.setState({ errorMessage: CONSTANT.NO_TEXT_IN_FIELD });
    }
  }

  /*Used to clear all fields and uploaded files from the post composition area.*/
  resetState() {
    //reset state
    this.setState({
      postText: "",
      displayPhoto: "",
      uploadPhoto: null,
      displayInputPrompt: false,
      displayImagePopup:false,
      youtubeURL: "",
      videoID: "",
      video: "",
      finalVideo: "",
      urlAdded: false,
    });
  }

  /*
   * Function to change current text field value.
   */
  handleTextFieldOnChange(e) {
    this.setState({ postText: e.target.value });
    if (this.state.errorMessage) {
      this.setState({ errorMessage: "" });
    }
  }

  /*
   * Function to remove the photo from the post
   */
  onRemovePhoto() {
    this.setState({
      displayPhoto: "",
      uploadPhoto: "",
    });
  }

  /*
   * Function to remove the video from the post
   */
  onRemoveVideo() {
    this.setState({
      videoID: "",
      youtubeURL: "",
      urlAdded: false,
    });
  }
  openPopUp(){
    this.setState({
      displayImagePopup:true,
      count:1
    })
  }
  closePopUp(){
    this.setState({
      displayImagePopup:false,
      displayCustomPopup:false
    })
  }

  openCustomPopUp(file){
    this.setState({
      displayImagePopup:false,
      displayCustomPopup:true,
      fileData:file,
      count:2,
      video: "",
      finalVideo: "",
    })
  }
  openCreationSuite(){
    this.setState({
      displayCreationSuite:true
    })
  }

  closeCreationSuite(){
    this.setState({
      displayCreationSuite:false,
      displayImagePopup: false,
      displayCustomPopup: false,
      fileData:null,
    })
  }
  /*
   * open youtube input popup
   */
  openPrompt() {
    this.setState({
      displayInputPrompt: true,
    });
  }

  /*
   * close youtube input popup
   */
  closePrompt() {
    this.setState({
      displayInputPrompt: false,
      youtubeURL: "",
    });
  }

  /*
   * on youtube input popup text change
   */
  onPromptFieldChange(e) {
    this.setState({
      youtubeURL: e.target.value,
    });
  }

  /*
   * on youtube input popup add pressed
   * extract the youtube video id from the url
   */
  onPromptAddPressed() {
    let id = "";
    let url = this.state.youtubeURL;

    // extract video id from url
    if (url.includes("watch?v=")) {
      let splitURL = url.split("watch?v=");
      id = splitURL[1].split("&")[0];
    } else {
      let splitURL = url.split("/");
      id = splitURL[3];
    }

    //set state and remove upload photo
    this.setState({
      videoID: id,
      displayInputPrompt: false,
      urlAdded: true,
      displayPhoto: "",
      uploadPhoto: "",
    });
  }

  render() {
    return (
      <div className="add-post-newsfeed-wrapper">
        <div className="add_post_container">
          <div className="newsfeed_profile_pic_text_field">
            <div className="profile-name">
              <div className="user-img">
                <ProfilePic
                  profilePic={this.state.profilePic}
                  className={"post_profile_pic"}
                />
              </div>
              <h4 className="text_dark_blue">{this.state.full_name}</h4>
            </div>
            <div className="add_post_text_field">
              {/* <Input
                name="write_post"
                inputType="post"
                placeholder={CONSTANT.WHATS_ON_YOUR_MIND}
                value={this.state.postText}
                handleChange={this.handleTextFieldOnChange}
              /> */}
              <TextArea
                name="write_post"
                placeholder={CONSTANT.WHATS_ON_YOUR_MIND}
                value={this.state.postText}
                handleChange={this.handleTextFieldOnChange}
                rows="1"
                cols="1"
              />
            </div>
          </div>
          {this.state.errorMessage ? (
            <div style={{ paddingLeft: "4%", paddingBottom: "4%" }}>
              <TextTheme
                message={this.state.errorMessage}
                className={"text_small text_red"}
              />
            </div>
          ) : null}

          {this.state.uploadPhoto ? (
            <div className="add_post_image">
              <img
                className="post_photo"
                alt="post_photo"
                src={this.state.displayPhoto}
              />
            </div>
          ) : null}
          {this.state.video ? (
            <div className="add_post_image" style={{ marginBottom: '12px'}}>
              <Player
                className="video-upload-preview"
                fluid={false}
                playsInline
                src={this.state.video}
              />
              </div>
          ) : null}

          {this.state.urlAdded ? (
            <div className="add_post_video">
              <img
                src={"https://i.ytimg.com/vi/" + this.state.videoID + "/0.jpg"}
                alt={"post_video"}
                className="post_video"
              />
              <div className="top_right_video">
                <ButtonBase
                  onClick={this.onRemoveVideo}
                  style={{ borderRadius: "10px", margin: "5px" }}
                >
                  <CancelIcon style={{ fontSize: 30, color: "#8D8D8D" }} />
                </ButtonBase>
              </div>
              <div className="bottom_middle_video">
                {CONSTANT.YOUTUBE_VIDEO_PREVIEW}
              </div>
            </div>
          ) : null}

          <div className="upload_button_post_button">
            <label className="post_upload_file">
              <img style={{ width: "40px" }} src={UploadPhoto} alt={"camera"} onClick={this.openPopUp} />
            </label>
            <div className="post_upload_file">
              <img
                alt={"video_camera"}
                style={{ width: "42px", marginTop: "1.5px" }}
                src={UploadVideo}
                onClick={this.openPrompt}
              />
            </div>
            <div className="post_button">
              <RoundedButton
                startIcon={
                  <SendIcon style={{ fontSize: 20, color: "white" }} />
                }
                title={CONSTANT.POST}
                handleOnClick={this.onPostSubmit}
                textThemeClassName="text_small text_bold text_white"
                buttonClassName="background_dark_orange"
                float="right"
                borderRadius="6px"
              />
            </div>
          </div>
        </div>
        {this.state.displayInputPrompt ? (
          <CustomInputPopup
            isOpen={true}
            popupTitle={CONSTANT.ADD_YOUTUBE_URL}
            acceptButtonClick={this.onPromptAddPressed}
            declineButtonClick={this.closePrompt}
            acceptButtonText={CONSTANT.ADD}
            declineButtonText={CONSTANT.DECLINE_BLOCK}
            textOnChange={this.onPromptFieldChange}
            inputPlaceholder={CONSTANT.TYPE_URL}
          />
        ) : null}
        {this.state.displayImagePopup ? (
          <CustomImagePopup
            isOpen={true}
            count = {this.state.count}
            closePopUp={this.closePopUp}
            handleImageChange={this.handleImageChange}
            openCreationSuite={this.openCreationSuite}
          />
        ) : null}
        {this.state.displayCustomPopup ? (
          <CustomImagePopup
            isOpen={true}
            count={this.state.count}
            closePopUp={this.closePopUp}
            fileUpload = {this.fileUpload}
            uploadApi = {this.uploadApi}
            openCreationSuite={this.openCreationSuite}
          />
        ) : null}
        {this.state.displayCreationSuite ? (
          <CustomCreationSuitePopup
            isOpen={true}
            fileData = {this.state.fileData}
            closeCreationSuite={this.closeCreationSuite}
            handleCreationSuiteUpload={this.handleCreationSuiteUpload}
          />
        ) : null}
      </div>
    );
  }
}

export default AddNewsfeedPost;
